<template>
<div>

<div style="padding:10px 50px; text-align:center">
  <img height="70px" src="https://ayurlifeworld.com/img/logo.jpg" alt="">
</div>
<van-tabs v-model="active">
  <van-tab title="Giriş Yap">
    <van-form style="margin-top:50px;"  @submit="handleSubmit">
      <van-field
        v-model="username"
        name="Username"
        label="Üye Kod"
        placeholder="Üyelik Kodu / T.c. Numarası"
        :rules="[{ required: true, message: 'Üye kod gerekli' }]"
      />
      <van-field
        v-model="password"
        type="password"
        name="Password"
        label="Şifre"
        placeholder="Şifre"
        :rules="[{ required: true, message: 'Şifre gerekli' }]"
      />
      <div style="margin: 16px;">
        <van-button block type="" native-type="submit">
          Giriş Yap
        </van-button>
      </div>
    </van-form>
{{error}}
  </van-tab>
  <van-tab title="Yeni Bayilik">
    <van-form v-if="form===1" @submit="onSubmit">
      <van-field
        v-model="ref_kod"
        label="Sponsor"
        name="Sponsor"
        placeholder="Sponsor Kodu"
        :rules="[{ required: true, message: 'Sponsor boş geçilemez' }]"
        @blur="sponsorkontrol"
      />
        <van-field
        v-model="tc"
        label="Tc Kimlik"
        placeholder="Tc Kimlik No"
        :rules="[{ required: true, message: 'Tc Kimlik boş geçilemez' }]"
        @blur="tcno"
      />
      <van-field
        v-model="isim"
        label="İsim"
        placeholder="Ad ve Soyad"
        :rules="[{ required: true, message: 'isim boş geçilemez' }]"
      />
      <van-field
        v-model="pass"
        type="password"
        label="Şifre"
        placeholder="Şifre"
        :rules="[{ required: true, message: 'Şifre boş geçilemez' }]"
      />
        <van-field
        v-model="pass2"
        type="password"
        label="Şifre"
        placeholder="Şifre Tekrar"
        :rules="[{ required: true, message: 'şifreler uyuşmuyor' }]"
      />
      <div style="margin: 16px;">
        <van-button round block type="info" native-type="submit">Gönder</van-button>
      </div>
    </van-form>  
  </van-tab>  
</van-tabs>

<van-popup v-model="show"><van-loading type="spinner" color="#fff" /></van-popup>
</div>
</template>

<script>
import {helper} from '@/helper';
import {router}  from '@/router';
import { userService } from '@/plugins/_services';
import {Toast} from 'vant'
import { Dialog } from 'vant';
import { Notify } from 'vant';

export default {

    data () {
        return {
        username: '',
        password: '',
        submitted: false,
        loading: false,
        returnUrl: '',
        error: '',
        active:0,
        // üyelik
        form:1,
       yeniuyekod:'',
       ref_kod:'',
       tc:'',
       isim:'',
       pass:'',
       pass2:'',
       show:false        
        }
    },
    created () {
        //userService.logout();
        this.returnUrl = this.$route.query.returnUrl || '/';
    },
    methods: {
      sponsorkontrol(){
        if (this.ref_kod)
        {
          this.show=true
          this.uye_kod_kontrol(this.ref_kod)
          .then(res=> {
            this.show=false
            Toast(res.ad)
          })
          .catch(err=>{
            this.show=false
            Toast("Sponsor Kodu Hatalı")
            this.ref_kod = ''
        })          
        }

      },
        handleSubmit (e) { //amaç kullanıcı adı ve şifrenin boş geçilememesi
            this.submitted = true;
            const { username, password } = this;
            if (!(username && password)) {
             return;
            }
            this.loading = true;
            userService.login(username, password)
                .then(res => {
                    if (res){router.push(this.returnUrl)}
                    else{
                        this.error ='Bilgiler hatalı ya da yetkisiz kullanıcı';
                        this.loading = false}
                })
                .catch (err => {this.error = err;this.loading = false;})
        },
      onSubmit(){
        if (this.pass === this.pass2){
          Dialog.confirm({
          title: 'Bayi Eklenecek',
          message:'Onaylıyormusunuz ?',
          }).then((result) => {
            this.show = true
            this.uye_kod_kontrol(Math.floor(Math.random() * 10000000000) + 1)
              .then(err=>{
                this.onSubmit()
              })
              .catch(res=>{
                  let data = {
                    uye_kod : res.kod,
                    ref_kod: this.ref_kod,
                    tcno : this.tc,
                    uye_ad : this.isim,
                    parola: this.pass,
                    kariyer_id : 1,
                    gun : 1, 
                    ay : 1, 
                    yil : 1, 
                  }
                  helper.request.post('bayi',data)
                  .then(response=>{
                      helper.request.post('bayi_bilgi',{table:'uye_bilgi',uye_kod:response.kod})
                        .then(resp=> {
                          this.yeniuyekod = resp.kod
                          helper.request.post('bayi_bilgi',{table:'uye_banka',uye_kod:resp.kod})
                          .then(()=>{
                            Toast("Bekleyiniz")
                            this.username =resp.kod
                            this.password = this.pass
                            setTimeout(() => {
                              this.handleSubmit()
                            }, 1000);
                            this.form = 1
                          })
                        })

                  })
                  .catch(err => {Toast('Tekrar Dene : '+err.message)
                  this.show = false
                  })               
              })

          })
          .catch(err=>{this.show=false})
        }
        else{
          Notify({ type: 'danger', message: 'Şifreler uyuşmuyor' });
        }
      },
      uye_kod_kontrol(value){
      return new Promise((resolve, reject) => {
          helper.request.get("uye_kod/"+value)
          .then(res=>{
          
            if (res.status){ resolve({
              status:res.status,
              kod:value,
              ad:res.ad
            })}
            else{ reject({
              kod:value
            }) }
          })
      })        
      },
      tcno(){
        helper.funcs.tckontrol(this.tc)
        .then(res => {
          if (res){
            helper.request.get("tckontrol/"+this.tc)
              .then(response=>{
                if (!response.status){
                  Notify({ type: 'danger', message: 'Tc Kimlik Kullanılıyor' });
                  this.tc = ''
                }
              })
          }
          else{
            Notify({ type: 'danger', message: 'Tc Kimlik yapısı uygun değil' });
            this.tc = ''
          }
        })
      },        
        }
    };
</script>


// WEBPACK FOOTER //
// src/components/LoginPage.vue